import { Container } from "@material-ui/core"
import { ArrowBackIosOutlined } from "@material-ui/icons"
import { BannerResponse, CategoryResponse, LeadBanner } from "api"
import { useGroupCardContext } from "components/Balance/GroupCardContext"
import Categories from "components/Categories/Categories"
import CompaniesBannerHome from "components/Companies/CompaniesBannerHome"
import { useGroupPurchasesContext } from "components/PurchasePage/GroupPurchasesContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import { StyledButtonPrimary } from "components/Reusable/Buttons"
import Storyly from "components/Storyly/Storyly"
import { useRouter } from "next/router"
import { useEffect, useRef } from "react"
import styled from "styled-components"
import GiftcardTypeStrip from "./GiftcardTypeStrip/GiftcardTypeStrip"
import MainBanner from "./Mainbanner/MainBanner"
import MainCard from "./MainCard/MainCard"

const StyledWrapper = styled.div`
  background-color: ${(p) => p.theme.colors.white};
  position: relative;
  padding: 0 0 40px 0;
  background-image: url(/);
  background-position: bottom left;
  background-repeat: no-repeat;

  background: url(/big-m.svg);
  background-position: -24px 102.2%;
  background-repeat: no-repeat, no-repeat;
  background-size: 141px 131px;

  overflow: hidden;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 0 0 128px 0;
    background-position: -72px 104.3%;
    background-size: 413px 385px;
  }
`

const StyledContainer = styled(Container)`
  padding: 16px 65px;
  max-width: none;
  font-family: NarkisBlock-Thin;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 15px 20px;
  }
  justify-content: flex-start;
  text-align: right;
  gap: 6px;
  display: flex;
  align-items: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 12px;
  }
`

const StyledBalanceButton = styled(StyledButtonPrimary)`
  margin-top: 78px;
  width: 100vw;
  border-radius: 0;
  justify-content: flex-start;
  font-size: 20px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.015em;
  text-align: right;
  height: 54px;
  // font-family: NarkisBlock;
  .MuiButton-label {
    gap: 6px;
    font-size: 20px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
    line-height: 26.4px;
    height: 68px;
    .MuiButton-label {
      gap: 12px;
      font-size: 24px;
    }
  }
`
type HomePageProps = {
  banners: BannerResponse[]
  categories: CategoryResponse[]
  setRefList: any
  companiesBanner: LeadBanner
  settings: any
}

const HomePage = ({
  banners,
  categories,
  setRefList,
  companiesBanner,
  settings,
}: HomePageProps) => {
  const ref = useRef<HTMLDivElement>()
  const categoriesRef = useRef<HTMLDivElement>()
  const { setPurchaseData, setPromotion, setVideoFile } = usePurchaseContext()
  const { setGroupCard } = useGroupCardContext()
  const { setGroupPurchasesData, setIsAdmin } = useGroupPurchasesContext()

  useEffect(() => {
    setRefList([categoriesRef])
    setVideoFile(null)
    setPurchaseData({})
    setGroupCard({})
    setGroupPurchasesData(null)
    setIsAdmin(false)
  }, [])

  const router = useRouter()

  useEffect(() => {
    const { giftcard } = router.query
    if (giftcard && giftcard === "sender") {
      const orderData = JSON.parse(localStorage.getItem("order"))
      const obj = {
        recipientName: `${orderData.firstName} ${orderData.lastName}`,
        recipientEmail: `${orderData.email}`,
        phoneNumber: `${orderData.mobilePhone}`,
        senderName: `${orderData.recipientName}`,
        senderLastName: `${orderData.recipientName}`,
        senderMobilePhone: `${orderData.recipientPhoneNumber}`,
        senderEmail: `${orderData.recipientEmail}`,
        senderBlessing: `${orderData.senderBlessing}`,
      }
      setPurchaseData(obj)
    } else if (giftcard === "other") {
      const orderData = JSON.parse(localStorage.getItem("order"))
      const obj = {
        senderName: `${orderData.firstName}`,
        senderLastName: `${orderData.lastName}`,
        senderMobilePhone: `${orderData.mobilePhone}`,
        senderEmail: `${orderData.email}`,
        senderBlessing: `${orderData.senderBlessing}`,
      }
      setPurchaseData(obj)
    } else {
      setPurchaseData({})
      setPromotion(null)
    }
  }, [router.query])

  return (
    <StyledWrapper>
      <StyledBalanceButton onClick={() => router.push("/balance")}>
        <StyledContainer>
          לבדיקת יתרת גיפטקארד
          <ArrowBackIosOutlined style={{ width: 20, height: 20 }} />
        </StyledContainer>
      </StyledBalanceButton>

      <Storyly />

      <MainCard defaultPrice={settings?.defaultPrice} />

      <Categories
        divRef={ref}
        scrollRef={categoriesRef}
        categoriesData={categories}
        isHomePage
      />

      <GiftcardTypeStrip data={categories} />

      <MainBanner divRef={ref} banners={banners} />

      <CompaniesBannerHome companiesBanner={companiesBanner} />
    </StyledWrapper>
  )
}

export default HomePage
